<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-richtext">
  <!-- Basic use of a rich text field. Wraps in a <div>. -->
  <div *scRichText="rendering.fields.sample"></div>

  <!-- Advanced usage of rich text field. Specifies a custom wrapper tag, turns off Sitecore editing, and has a CSS class on the wrapper -->
  <section *scRichText="rendering.fields.sample2; editable: false"
    clas="text-center"
    data-sample="other-attributes-pass-through"
  >
  </section>
</app-styleguide-specimen>
